import React, { useState } from 'react';
import type { FunctionComponent } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { openLiveChat } from '@whizz/react-acquire';
import { Alert } from '../../components';
import { getIconComponent } from '../../util/reactFunc';
import WelcomeOwl from './WelcomeOwl';

type Props = {
  isNz?: boolean;
  owlWidth?: number;
  owlHeight?: number;
  owlClassName?: string;
  textClassName?: string;
  mutedClassName?: string;
};

const WelcomeMoreInfoTip: FunctionComponent<Props> = ({
  isNz = false,
  owlWidth = 68,
  owlHeight = 68,
  owlClassName,
  textClassName = 'text-black',
  mutedClassName = 'text-gray-600',
}) => {
  const { translate } = useI18n();
  const [ showInfo, setShowInfo ] = useState(false);

  return (
    <div>
      <div className={'flex items-center gap-3'}>
        <WelcomeOwl width={owlWidth} height={owlHeight} className={owlClassName} />
        <div className={`font-bold text-base ${textClassName}`}>
          <div className={'mb-2'}>{translate('pages.WELCOME.COMMON.NOT_SURE')}</div>
          <p>
            {translate('pages.WELCOME.COMMON.CLICK_INFO_PREFIX')}{' '}
            <button
              type={'button'}
              onClick={() => setShowInfo(!showInfo)}
              className={'inline-flex align-middle mx-1'}
            >
              {getIconComponent('InfoCircle', 'sm', 'primary')}
            </button>{' '}
            {translate('pages.WELCOME.COMMON.CLICK_INFO_SUFFIX')}
          </p>
        </div>
      </div>
      <Alert disableIcon show={showInfo} className={'my-md'}>
        <p>
          {translate('pages.WELCOME.COMMON.INFO_DEMO_PREFIX')}{' '}
          <span className={'inline-flex align-middle mx-1'}>{getIconComponent('InfoCircle', 'sm', 'primary')}</span>
        </p>
        <p>{translate('pages.WELCOME.COMMON.INFO_DEMO_SUFFIX')}</p>
      </Alert>
      <div className={`mt-2.5 ${mutedClassName}`}>
        {isNz ? (
          <>
            {translate('pages.WELCOME.COMMON.STILL_NOT_SURE_EMAIL_PREFIX')}{' '}
            <a
              href={`mailto:${translate('pages.WELCOME.COMMON.NO_ADMIN_EMAIL')}`}
              className={`font-extrabold ${textClassName}`}
            >
              {translate('pages.WELCOME.COMMON.NO_ADMIN_EMAIL')}
            </a>
          </>
        ) : (
          <>
            {translate('pages.WELCOME.COMMON.STILL_NOT_SURE_PREFIX')}{' '}
            <button
              type={'button'}
              onClick={() => openLiveChat()}
              className={`font-extrabold ${textClassName}`}
            >
              {translate('pages.WELCOME.COMMON.LIVE_CHAT')}
            </button>{' '}
            {translate('pages.WELCOME.COMMON.STILL_NOT_SURE_SUFFIX')}
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeMoreInfoTip;
